import React from 'react'

export const iowaSetupVars = {
  siteId: 'ia',
  pathPrefix: '/ia',
  topScreenshotUrl: '/images/iowa/marketing/Images/Mockup@2x.png',
  menuHeader: "Discover Iowa's Solution for:",
  appUrl: 'https://ia.headed2.com',
  logoImg: '/images/assets/iowa/horizontal/dark.svg',
  headerTitle: `The Iowa CareerExplorer`,
  headerTitleDescription: (
    <div>
      <p>
        The Iowa CareerExplorer is a state-supported career exploration and planning
        system designed to support career and college readiness, district strategy, and
        transition planning.
      </p>
      <h4>
        With a <b>FREE</b> Headed2 account, you will have access to:
      </h4>
      <ul className="top-features">
        <li className="onetprofile">Occupation & College Info</li>
        <li className="financial-literacy">Financial Literacy Tools</li>
        <li className="onetassess">Self Assessments</li>
        <li className="plantool">Planning Tools</li>
      </ul>
    </div>
  ),
  sponsorMsg: (
    <span>
      Perfect for helping students develop, revise, and implement an{' '}
      <b>Individual Career and Academic Plan</b>. Our lesson plans and data-rich system
      have earned us the endorsement of the <b>Iowa Department of Education</b>.
    </span>
  ),
  sponsorImg: '/images/iowa/marketing/Images/H2-IA-Iowa_DOE_Approved.jpg',
  brochureDownloadImg: '/images/www/new/homepage/Homepage-Download-CCZ@2x.png',
  otherSites: [
    {
      url: 'https://www.pacareerzone.org',
      logoSrc: '/images/arkansas/marketing/Images/Export/PA-logo.svg'
    },
    {
      url: 'https://www.cacareerzone.org',
      logoSrc: '/images/arkansas/marketing/Images/Export/CCZ-logo.svg'
    },
    {
      url: 'https://nv.headed2.com',
      logoSrc: '/images/arkansas/marketing/Images/Export/NV-logo.svg'
    },
    {
      url: 'https://va.headed2.com',
      logoSrc: '/images/arkansas/marketing/Images/Export/VA-logo.svg'
    }
  ]
}
